import React from "react";
import * as styles from "./LoginForm.module.css";

interface Props {
  message: string;
}

export const OfflineMsg: React.FC<Props> = ({ message }) => {
  return <div className={styles.offlineMsg}>{message}</div>;
};
